interface TierProgressProps {
  paidCount: number;
  milestoneTarget?: number;
  bonusAmount?: number;
}

export const TierProgress = ({
  paidCount,
  milestoneTarget = 10,
  bonusAmount = 15000,
}: TierProgressProps) => {
  const progress = Math.min(
    100,
    Math.round((paidCount / milestoneTarget) * 100)
  );

  return (
    <section className="tier-rail">
      <div className="row-h">
        <div>
          <div className="lbl">Next milestone</div>
          <div className="rne-h3">
            {paidCount} of {milestoneTarget} paid friends · ₦
            {bonusAmount.toLocaleString('en-NG')} bonus
          </div>
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 800,
            color: 'var(--rne-brand-green-press)',
          }}
        >
          {progress}%
        </div>
      </div>
      <div className="rne-progress">
        <span style={{ width: `${progress}%` }} />
      </div>
      <div className="ticks">
        <span className="reached">Start</span>
        <span className={paidCount >= 3 ? 'reached' : ''}>3 friends</span>
        <span className={paidCount >= 5 ? 'reached' : ''}>5 friends</span>
        <span className={paidCount >= milestoneTarget ? 'reached' : ''}>
          {milestoneTarget} friends · bonus
        </span>
      </div>
    </section>
  );
};
